import { render, staticRenderFns } from "./LastCall.vue?vue&type=template&id=f88d0ee8&scoped=true&"
import script from "./LastCall.vue?vue&type=script&lang=js&"
export * from "./LastCall.vue?vue&type=script&lang=js&"
import style0 from "./LastCall.vue?vue&type=style&index=0&id=f88d0ee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88d0ee8",
  null
  
)

export default component.exports